<!--<template>-->
<!--  <div>-->
<!--    <hollow-dots-spinner-->
<!--      :animationDuration="750"-->
<!--      :dotSize="12"-->
<!--      :dotsNum="3"-->
<!--      :color="color"-->
<!--    />-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import {HollowDotsSpinner} from "epic-spinners";-->

<!--export default {-->
<!--  name: "Loader",-->
<!--  components: {-->
<!--    HollowDotsSpinner,-->
<!--  },-->
<!--  props: {-->
<!--    color: {-->
<!--      type: String,-->
<!--      default: '#723BE3'-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<template>
  <svg
    class="timeit-loader"
    :width="size"
    :height="size"
    viewBox="0 0 720 720"
    role="img"
    aria-label="Loading"
    :style="{ '--dur': duration + 's' }"
  >
    <g class="tl-group">
      <path class="tl-p1" fill="#6063AC" d="M424.816 259.106H297.408C276.487 259.106 259.327 276.034 259.327 297.193V424.62C259.327 445.544 276.252 462.707 297.408 462.707H424.816C445.737 462.707 462.898 445.779 462.898 424.62V297.193C462.898 276.269 445.973 259.106 424.816 259.106Z" />
      <path class="tl-p2" fill="#DE4699" d="M513.907 170.235H386.5C365.578 170.235 348.418 187.163 348.418 208.322V221.723H461.957C482.878 221.723 500.038 238.651 500.038 259.81V373.366H513.907C534.829 373.366 551.989 356.438 551.989 335.279V208.087C551.989 187.163 535.064 170 513.907 170V170.235Z" />
      <path class="tl-p3" fill="#F79A69" d="M221.95 461.766V348.681H208.081C187.16 348.681 170 365.608 170 386.768V513.724C170 534.649 186.925 551.811 208.081 551.811H335.489C356.411 551.811 373.571 534.884 373.571 513.724V499.853H260.032C239.111 499.853 221.95 482.926 221.95 461.766Z" />
    </g>
  </svg>
</template>

<script setup>
defineProps({
  size:     { type: [Number, String], default: 60 },
  duration: { type: Number, default: 2.4 }, // seconds per loop
})
</script>

<style scoped>
.tl-group {
  transform-box: view-box;
  transform-origin: center;           /* rotate about the mark's center */
  animation: atkGroup var(--dur) linear infinite;
}
.tl-p1, .tl-p2, .tl-p3 {
  transform-box: fill-box;
  transform-origin: center;           /* each piece pops on its own center */
  animation-duration: var(--dur);
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
}
.tl-p1 { animation-name: atkPop1; }
.tl-p2 { animation-name: atkPop2; }
.tl-p3 { animation-name: atkPop3; }

/* whole mark ticks 90° like a clock hand */
@keyframes atkGroup {
  0%   { transform: rotate(0deg); }
  34%  { transform: rotate(0deg); animation-timing-function: cubic-bezier(.62,0,.2,1.12); }
  50%  { transform: rotate(90deg); }
  100% { transform: rotate(90deg); }
}
/* stagger baked into % (no delay) so the loop resets while pieces are invisible */
@keyframes atkPop1 {
  0%   { opacity:0; transform:scale(.3); }
  8%   { opacity:1; transform:scale(1.07); }
  13%  { transform:scale(1); }
  66%  { opacity:1; transform:scale(1); }
  78%  { opacity:0; transform:scale(.3); }
  100% { opacity:0; transform:scale(.3); }
}
@keyframes atkPop2 {
  0%,4% { opacity:0; transform:scale(.3); }
  13%   { opacity:1; transform:scale(1.07); }
  18%   { transform:scale(1); }
  68%   { opacity:1; transform:scale(1); }
  81%   { opacity:0; transform:scale(.3); }
  100%  { opacity:0; transform:scale(.3); }
}
@keyframes atkPop3 {
  0%,8% { opacity:0; transform:scale(.3); }
  18%   { opacity:1; transform:scale(1.07); }
  23%   { transform:scale(1); }
  70%   { opacity:1; transform:scale(1); }
  84%   { opacity:0; transform:scale(.3); }
  100%  { opacity:0; transform:scale(.3); }
}

@media (prefers-reduced-motion: reduce) {
  .tl-group, .tl-p1, .tl-p2, .tl-p3 { animation: none; }
  .tl-p1, .tl-p2, .tl-p3 { opacity: 1; }  /* show the assembled mark, static */
}
</style>
